<!-- Breadcrumb -->
<ol class="breadcrumb">
  <li class="breadcrumb-item">
    <a routerLink="">Início</a>
  </li>
  <li class="breadcrumb-item">Minha Conta</li>
  <li class="breadcrumb-item active">
    Relação de Bilhetes
  </li>
</ol>
<!-- //.Breadcrumb -->

<h2 class="titulo-interna">Bilhetes Gerados no Sorteio {{sorteio?.numSorteioPremiacaoConsumidor}}</h2>

<p>Extra&ccedil;&atilde;o: {{sorteio?.desTipoSorteio}}</p>

<p>Veja aqui os seus bilhetes: </p>

<div *ngIf="bilhetes?.length == 0" class="alert alert-danger col-sm-12">
  Nenhum bilhete encontrado.
</div>

<div class="content-tab">

  <div class="row">
    <div class="col-12 col-md-4" *ngFor="let item of bilhetes" >
      <div class="card-ticket">
          <div class="card">
            <img alt="gerarParteNomeImagem" [src]="'./assets/images/icon-bilhete-'+gerarParteNomeImagem(item)+'.svg'" width="62">
            <div class="card-body">
              <h4 class="card-title">Bilhete {{gerarNomeOrigemBilhete(item)}}</h4>
              <p class="card-text text-blue">Sorteio nº {{item.num_sorteio_premiacao_consumidor}}</p>
              <br>
              <p class="card-text text-blue">Bilhete nº {{item.num_bilhete_consumidor}}</p>
            </div>
          </div>
      </div>
    </div>

  </div>
  <button type="button" class="btn btn-secondary" (click)="voltar()">Voltar para Sorteio</button>
  <div class="card-block" *ngIf="bilhetes?.length > 0">
    <ngb-pagination [collectionSize]="totalBilhetes" [(page)]="pagina" [pageSize]="tamanhoPagina" [maxSize]="5" [rotate]="false" [ellipses]="false"
      [boundaryLinks]="true" (pageChange)="pageChange($event)" class="d-flex justify-content-end"></ngb-pagination>
  </div>
</div>





// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-detalhe-sorteio/consumidor-visualizar-bilhetes/consumidor-visualizar-bilhetes/consumidor-visualizar-bilhetes.component.html